import React, { useState, useEffect } from 'react';
import styles from './ImageUploadSection.module.css';

function ImageUploadSection({ title,  instructions }) {
    const [preview, setPreview] = useState(null);

    // 이미지 업로드 핸들러
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            setPreview(imageUrl);
        }
    };

    // 이미지 삭제 핸들러
    const handleImageRemove = () => {
        if (preview) {
            URL.revokeObjectURL(preview); // 메모리 해제
            setPreview(null);
        }
    };

    // 컴포넌트 언마운트 시 메모리 정리
    useEffect(() => {
        return () => {
            if (preview) URL.revokeObjectURL(preview);
        };
    }, [preview]);

    return (
        <div className={styles.imageSection}>
            <div className={styles.imageBox}>
                {preview ? (
                    <>
                        <img src={preview} alt={`${title} Preview`} />
                        <button
                            type="button"
                            className={styles.removeButton}
                            onClick={handleImageRemove}
                            aria-label="이미지 삭제"
                        >
                            ✖
                        </button>
                    </>
                ) : (
                    <div className={styles.placeholder}>사진 등록</div>
                )}
                <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    className={styles.fileInput}
                />
            </div>

            <div className={styles.instructions}>
                <h3>{title}</h3>
                <ul>
                    {instructions.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default ImageUploadSection;
